var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 11.9997C6.30033 11.9997 5.98644 11.8691 5.72533 11.608C5.46421 11.3469 5.33366 11.033 5.33366 10.6663V2.66634C5.33366 2.29967 5.46421 1.98579 5.72533 1.72467C5.98644 1.46356 6.30033 1.33301 6.66699 1.33301H12.667C13.0337 1.33301 13.3475 1.46356 13.6087 1.72467C13.8698 1.98579 14.0003 2.29967 14.0003 2.66634V10.6663C14.0003 11.033 13.8698 11.3469 13.6087 11.608C13.3475 11.8691 13.0337 11.9997 12.667 11.9997H6.66699ZM6.66699 10.6663H12.667V2.66634H6.66699V10.6663ZM4.00033 14.6663C3.63366 14.6663 3.31977 14.5358 3.05866 14.2747C2.79755 14.0136 2.66699 13.6997 2.66699 13.333V3.99967H4.00033V13.333H11.3337V14.6663H4.00033Z",
    fill: "#BB448B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file_copy.8db8b42afe34d34b62149fb6afc1cda9.svg";
export { ForwardRef as ReactComponent };